import React, { useState } from 'react';

import classNames from 'classnames';
import FilledStarIcon from 'icons/filled-star.svg';
import StarIcon from 'icons/star.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  useCreateFavouriteUserFolderMutation,
  useDestroyFavouriteUserFolderMutation,
} from 'components/hooks/favouriteUserFolderMutations';

import { useBreadBoard } from 'components/contexts/Toaster';

export default function FavouriteFolderToggleButton({
  favouriteUserFolderId,
  folderId,
}) {
  const breadBoard = useBreadBoard();

  const createFavouriteUserFolderMutation =
    useCreateFavouriteUserFolderMutation();

  const destroyFavouriteUserFolderMutation =
    useDestroyFavouriteUserFolderMutation();

  const [isHovered, setIsHovered] = useState(false);

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projectsDashboard.components.FavouriteFolderToggleButton',
  });

  const handleAddToFavouritesClick = () => {
    createFavouriteUserFolderMutation.mutate(
      { favouriteUserFolderParams: { folder_id: folderId, position: 1 } },
      { onError: breadBoard.addInedibleToast },
    );
  };

  const handleRemoveFromFavouritesClick = () => {
    destroyFavouriteUserFolderMutation.mutate(
      { id: favouriteUserFolderId },
      { onError: breadBoard.addInedibleToast },
    );
  };

  const isFavourited = !!favouriteUserFolderId;
  const FavouriteIcon = isFavourited ? FilledStarIcon : StarIcon;

  return (
    <button
      className='tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-bg-transparent tw-p-0 hover:tw-bg-blue-050 disabled:tw-pointer-events-none disabled:tw-opacity-30'
      data-element-name='favourite-folder-toggle'
      disabled={
        createFavouriteUserFolderMutation.isLoading ||
        destroyFavouriteUserFolderMutation.isLoading
      }
      onClick={() => {
        isFavourited ?
          handleRemoveFromFavouritesClick()
        : handleAddToFavouritesClick();
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <FavouriteIcon
        className={classNames(
          isHovered ? '[&_path]:tw-fill-blue-500'
          : isFavourited ?
            '[&_path]:tw-fill-blue-300 [&_path]:group-hover/row:tw-fill-blue-400'
          : '[&_path]:tw-fill-grey-500 [&_path]:group-hover/row:tw-fill-grey-700',
        )}
        height={20}
        width={20}
      />
      <span className='tw-sr-only'>
        {isFavourited ? i18nT('remove') : i18nT('add')}
      </span>
    </button>
  );
}

FavouriteFolderToggleButton.propTypes = {
  favouriteUserFolderId: PropTypes.string,
  folderId: PropTypes.string.isRequired,
};
